import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'menuButton', 'overlay', 'closeButton']
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.handleEscape = this.handleEscape.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    
    if (this.openValue) {
      this.open()
    }
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscape)
    document.removeEventListener('click', this.handleClickOutside)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    this.openValue ? this.close() : this.open()
  }

  open() {
    this.openValue = true
    
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove('hidden')
      this.menuTarget.setAttribute('aria-hidden', 'false')
    }
    
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove('hidden')
      this.overlayTarget.classList.add('block')
      
      setTimeout(() => {
        this.overlayTarget.classList.add('opacity-100')
        this.overlayTarget.classList.remove('opacity-0')
      }, 10)
    }
    
    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute('aria-expanded', 'true')
    }
    
    document.addEventListener('keydown', this.handleEscape)
    setTimeout(() => {
      document.addEventListener('click', this.handleClickOutside)
    }, 100)
    
    this.focusFirstMenuItem()
  }

  close() {
    this.openValue = false
    
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add('hidden')
      this.menuTarget.setAttribute('aria-hidden', 'true')
    }
    
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add('opacity-0')
      this.overlayTarget.classList.remove('opacity-100')
      
      setTimeout(() => {
        this.overlayTarget.classList.add('hidden')
        this.overlayTarget.classList.remove('block')
      }, 300)
    }
    
    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute('aria-expanded', 'false')
      this.menuButtonTarget.focus()
    }
    
    document.removeEventListener('keydown', this.handleEscape)
    document.removeEventListener('click', this.handleClickOutside)
  }

  closeViaOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape' && this.openValue) {
      event.preventDefault()
      this.close()
    }
  }

  handleClickOutside(event) {
    if (!this.menuTarget.contains(event.target) && 
        !this.menuButtonTarget.contains(event.target) && 
        this.openValue) {
      this.close()
    }
  }

  focusFirstMenuItem() {
    if (this.hasMenuTarget) {
      const firstLink = this.menuTarget.querySelector('a, button')
      if (firstLink) {
        firstLink.focus()
      }
    }
  }

  handleTabKey(event) {
    if (!this.openValue || event.key !== 'Tab') return
    
    const focusableElements = this.menuTarget.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])'
    )
    
    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]
    
    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        event.preventDefault()
        lastElement.focus()
      }
    } else {
      if (document.activeElement === lastElement) {
        event.preventDefault()
        firstElement.focus()
      }
    }
  }

  openValueChanged() {
    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute('aria-expanded', this.openValue)
    }
  }
}